import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
    title: "选择列表显示数据",
    width: "600px",
    "append-to-body": "",
    "close-on-click-modal": false,
    "before-close": _ctx.handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, { onClick: _ctx.handleResetColumn }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("恢复默认", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          onClick: _ctx.handleClose,
          type: "danger"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleSetColumn
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("确定", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_checkbox_group, {
        modelValue: _ctx.columnCheckList,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.columnCheckList) = $event)),
        class: "columnSet"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_draggable, {
            list: _ctx.localFields,
            itemKey: _ctx.getColIdentity,
            "ghost-class": "ghost",
            "chosen-class": "chosenClass",
            animation: "300"
          }, {
            item: _withCtx(({ element }) => [
              _createVNode(_component_el_checkbox, {
                value: _ctx.getColIdentity(element),
                label: element.fieldName
              }, null, 8, ["value", "label"])
            ]),
            _: 1
          }, 8, ["list", "itemKey"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}